<script lang="ts" setup>
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'
import { brand } from '@/config/brands'
import { prefixCDN } from '@/utils/cdn'

const props = defineProps<{
  module: any
  config: HomePageConfig
  currentTagId: string
  cardClass?: string
  headerClass?: string
  gotoTags: (id: string) => void
  getCurrentShowTags: (col: any) => any[]
}>()

// 标签背景色循环数组
const tagBgColors = ['#FFEAEA', '#E1F6F9', '#FAE9F9', '#E3F0FD', '#FFF6DA', '#E7EAFE']

// hot 图标路径
const hotIconUrl = prefixCDN(`/images/${brand}/tags/hot-icon-red.png`)

// 获取标签背景色
function getTagBgColor(index: number): string {
  return tagBgColors[index % tagBgColors.length]
}

function handleSeeAll() {
  props.gotoTags(props.currentTagId)
}

// 点击标签直接进入详情页
function handleTagClick(tagId: string) {
  props.gotoTags(tagId)
}
</script>

<template>
  <div class="tags-container p-4 pt-0">
    <ModuleCard
      :title-text="module.showName"
      :action-text-value="config.texts.seeAll"
      :card-class="cardClass"
      :header-class="headerClass"
      @action="handleSeeAll"
    >
      <!-- 标签区域 -->
      <div class="mt-2 rounded-12px">
        <div class="flex flex-wrap">
          <div
            v-for="(tag, index) in getCurrentShowTags(module)" :key="tag.id"
            class="tag-button flex items-center justify-center rounded-full mt-2 text-12px whitespace-nowrap py-1 px-3 mr-2"
            :style="{ backgroundColor: getTagBgColor(index) }"
            @click="handleTagClick(tag.id)"
          >
            <img
              v-if="tag.isHot"
              :src="hotIconUrl"
              class="mr-1" style="width: 12px; height: 12px;"
            >
            {{ tag.tagName }}
          </div>
        </div>
      </div>
    </ModuleCard>
  </div>
</template>

<style lang="scss" scoped>
// 标签按钮样式
.tag-button {
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
}
</style>
